<!-- no divs here to integrate nicely into parent -->

<button 
  hisImage="PROJECT"
  [title]="'common.components.jobConfigurationPanel.actions.showLastExecutionProtocol' | hisUi"
  (click)="showJobDetails()">
</button>


<p-dialog
  appendTo="body"
  [(visible)]="jobDetailsVisible"
  [modal]="true" [blockScroll]="true"
  (onHide)="hideJobDetails()"
  [header]="'common.components.jobConfigurationPanel.lastExecutionProtocol.title' | hisUi">

  <div>
    <div class="details">
      <div class="detailPresentationList">
        <div class="layoutBlock detailPresentationListItem">
          <div class="columnDetailLabel detailPresentationListLabel"><span>{{'cs.sys.reporting.jobexecutioncontext.report_name' | hisUi}}:</span></div>
          <div class="columnDetailContent detailPresentationListContent"><span>{{jobStatus.jobName}}</span></div>
        </div>
        <div class="layoutBlock detailPresentationListItem">
          <div class="columnDetailLabel detailPresentationListLabel"><span>{{'cs.sys.reporting.jobexecutioncontext.status' | hisUi}}:</span></div>
          <div class="columnDetailContent detailPresentationListContent"><span>{{jobStatus.statusMsgKey | hisUi}}</span></div>
        </div>
        <div class="layoutBlock detailPresentationListItem">
          <div class="columnDetailLabel detailPresentationListLabel"><span>{{'cs.sys.reporting.jobexecutioncontext.startdate' | hisUi}}:</span></div>
          <div class="columnDetailContent detailPresentationListContent"><span>{{jobStatus.startedAt | hisDate: 'medium'}}</span></div>
        </div>
        <div class="layoutBlock detailPresentationListItem">
          <div class="columnDetailLabel detailPresentationListLabel"><span>{{'cs.sys.reporting.jobexecutioncontext.enddate' | hisUi}}:</span></div>
          <div class="columnDetailContent detailPresentationListContent"><span>{{jobStatus.finishedAt | hisDate: 'medium'}}</span></div>
        </div>
      </div>
    </div>

    <p-panel header="{{'cs.sys.reporting.jobexecutioncontext.protocol.title' | hisUi}}">
      @if (!loggingLines || loggingLines.length === 0) {
        <p>
          {{'cs.sys.notification.noNotification' | hisUi}}
        </p>
      }

      @if (loggingLines && loggingLines.length > 0) {
        <p-table #table
                 [value]="loggingLines"
                 [paginator]="true"
                 [rows]="rowsPerPage"
                 [responsive]="true"
                 (onPage)="onPageChange($event)">
          <ng-template pTemplate="header">
            <tr>
              <th>{{'cs.sys.notification.Notification.type' | hisUi}}</th>
              <th>{{'cs.sys.notification.Notification' | hisUi}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-line>
            <tr>
              <td>{{line.type}}</td>
              <td>{{line.message}}</td>
            </tr>
          </ng-template>
            <ng-template pTemplate="paginatorright">
                @if (loggingLines) {
                <div>
                    <his-rows-per-page #resultRowsPerPageComponent
                                       [resultRowsPerPage]="10"
                                       [(rowsPerPage)]="rowsPerPage"
                                       (rowsPerPageChange)="onRowsPerPageChange($event); table.reset()"
                                       [maxRows]="300"
                                       [resultRowsPerPage]="rowsPerPage"
                                       [totalRowCount]="loggingLines.length"
                                       [currentPageNumber]="currentPage"
                                       [totalNumberOfPages]="loggingLines ? math.ceil(loggingLines.length / rowsPerPage) : 0">
                    </his-rows-per-page>
                </div>
                }
            </ng-template>
        </p-table>
      }
    </p-panel>

    <!-- Dokument erneut downloaden, falls (noch) verfügbar -->
    @if (jobStatus && jobStatus.resultDocumentUrl) {
      <div>
        {{('common.download.file' | hisUi) + ':'}}
        <a  [href]="jobStatus.resultDocumentUrl"
          hisImage="DOWNLOAD"
          class="icon"
          [title]="'common.download.file' | hisUi">
        </a>
      </div>
    }
  </div>

  <ng-template #footer>
    <button type="button" (click)="hideJobDetails()">{{'image.alt.minus_circ' | hisUi}}</button>
  </ng-template>
</p-dialog>
